// Lib
import { avgOutboundClickRatePerPinConfig } from '@/lib/analytics/kpis/pinterest/avgOutboundClickRatePerPin';
import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerOutboundClickRateConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof KPIDefault
> = {
    ...avgOutboundClickRatePerPinConfig,
    id: 'outbound_click_rate',
    size: SIZE_50,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
